import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import validateUser from "../validation/validateUser";
import "./AdventureDetail.css";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const AdventureDetail = () => {
  const { id } = useParams();

  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [person, setPerson] = useState("");
  const [price, setPrice] = useState("");
  const [images, setImages] = useState([]);

  const [detail, setDetail] = useState({});
  const [errors, setErrors] = useState({});

  const getDetail = async () => {
    try {
      let response = await axios.get(
        `https://mtrip-dynamic.herokuapp.com/adventures/detail?adventure=${id}`
      );
      console.log(response);
      setDetail(response.data);
      setImages(response.data.images);
    } catch (err) {
      console.log(err);
    }
  };

  const getReserved = async (data) => {
    try {
      await axios.post(
        " https://mtrip-dynamic.herokuapp.com/reservations/new",
        data
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => getDetail(), []);

  const reserveUser = (e) => {
    e.preventDefault();
    const user = {
      name,
      date,
      person,
      adventure: id,
    };
    const { errors, isInvalid } = validateUser(user);
    if (isInvalid) {
      setErrors(errors);
    } else {
      setErrors({});
      window.alert("SuccessFully reserved...!!");
      getReserved(user);
    }
  };
  return (
    <div className="container">
      {detail.reserved === true && (
        <div className="alert alert-success mt-5" role="alert">
          Greetings! Reservation for this adventure is successful. (Click
          <Link to="/reservations" className="alert-link ms-1 me-1">
            here
          </Link>
          to view your reservations)
        </div>
      )}
      <div className="row">
        <div className="col-lg-8 col-sm-6 col-xs-12">
          <div className="card">
            <h1 className="ms-3">{detail.name}</h1>
            <p className="text-secondary fs-4 ms-3">{detail.subtitle}</p>
            <div className="card-body">
              <div
                id="carouselExampleInterval"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div
                    className="carousel-item active"
                    data-bs-interval="10000"
                  >
                    <img
                      src={images[0]}
                      className="d-block w-100 img-fluid"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item" data-bs-interval="2000">
                    <img
                      src={images[1]}
                      className="d-block w-100 img-fluid"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={images[2]}
                      className="d-block w-100 img-fluid"
                      alt="..."
                    />
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExampleInterval"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExampleInterval"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
              <div className="info card-body">{detail.content}</div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-sm-12 col-xs-12 2 mt-5 mt-sm-0">
          <div className="card">
            <div className="card-body">
              {detail.available ? (
                <form onSubmit={reserveUser}>
                  <div className="mb-3">
                    <label htmlFor="name">Name</label>
                    <input
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    <div className="invalid-feedback">{errors.name}</div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="data">Pick a Date</label>
                    <input
                      type="date"
                      className={`form-control ${
                        errors.date ? "is-invalid" : ""
                      }`}
                      id="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                    <div className="invalid-feedback">{errors.date}</div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="price">
                      Person(s) ₹ {detail.costPerHead} per head
                    </label>
                    <input
                      className={`form-control ${
                        errors.num ? "is-invalid" : ""
                      }`}
                      type="number"
                      id="price"
                      value={person}
                      onChange={(e) => setPerson(e.target.value)}
                    />
                    <div className="invalid-feedback">{errors.num}</div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="">Total</label>
                    <input
                      className="form-control"
                      name=""
                      value={person * detail.costPerHead}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </div>
                  <button className="btn btn-warning" style={{ width: "100%" }}>
                    Reserve
                  </button>
                </form>
              ) : (
                <div>
                  <h2 className="card-header">Sold Out!</h2>
                  <p>
                    This activity is currently sold out. But there's a lot more
                    to
                    <Link to="/" className="text-warning">
                      explore.
                    </Link>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdventureDetail;
